export default __webpack_public_path__ + "static/media/sponsor-banner-cn.b01af110.webp";